module.exports = __webpack_public_path__ + "static/media/entang.6f95d7c2.png";